module.exports = __webpack_public_path__ + "img/16.87476b9a.svg";